import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack, type SxProps, type Theme } from "@mui/material";

import { type findMatchingPayBreakdown } from "../../lib/estimatedPay";

interface ShiftDaysDisplayProps {
  isOffered: boolean;
  weekdayOffered: boolean;
  weekdayPayRate: ReturnType<typeof findMatchingPayBreakdown>;
  weekendOffered: boolean;
  weekendPayRate: ReturnType<typeof findMatchingPayBreakdown>;
  isWeekendAndWeekdayPayRateSame: boolean;
  shiftTypeLabel: string;
  sx?: SxProps<Theme>;
}

export function ShiftDaysDisplay(props: ShiftDaysDisplayProps) {
  const {
    isOffered,
    weekdayOffered,
    weekdayPayRate,
    weekendOffered,
    weekendPayRate,
    isWeekendAndWeekdayPayRateSame,
    shiftTypeLabel,
    sx,
  } = props;

  return (
    <Stack spacing={3} flex="1 1 0%" pl={8} aria-label={`${shiftTypeLabel} shift days`} sx={sx}>
      {isOffered ? (
        <>
          {weekdayOffered && isDefined(weekdayPayRate) && (
            <Text variant="body1">Mon - {isWeekendAndWeekdayPayRateSame ? "Sun" : "Fri"}</Text>
          )}
          {!isWeekendAndWeekdayPayRateSame && weekendOffered && isDefined(weekendPayRate) && (
            <Text variant="body1">Weekends</Text>
          )}
        </>
      ) : (
        <Text variant="body1" py={4} color={(theme) => theme.palette.text.tertiary}>
          Not offered
        </Text>
      )}
    </Stack>
  );
}
